@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.notifications

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.notifications.ExtendedNotificationDto

object GetPassengerNotificationsEndpoint :
    EndPoint<GetPassengerNotificationsEndpoint.Request, GetPassengerNotificationsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
    )

    class Response(
        val list: Array<ExtendedNotificationDto>,
    )
}